import "./assets/css/vendor/bootstrap.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-table/react-table.css";

import themeColor from "./theme-loader";

// 👇 Import the default theme (purple) as the base
import "./assets/css/sass/themes/gogo.light.purple.scss";

// 👇 Import orange theme overrides as a separate module
// This ensures both themes are included in the build
// import "./assets/css/sass/themes/gogo.light.orange.scss";

// 👇 Apply orange theme overrides if needed
if (themeColor === 'light.orange') {
  // Create a style element to override the navbar color for orange theme
  const style = document.createElement('style');
  style.textContent = `
    .navbar {
      background-color: rgb(133, 233, 102) !important;
    }
  `;
  document.head.appendChild(style);
}

require("./AppRenderer");
